import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
@Component({
  selector: 'app-funcionario-pj',
  templateUrl: './funcionario-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./funcionario-pj.component.css']
})
export class FuncionarioPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.funcionario===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.funcionario===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
